import { LAWNSTARTER } from '@/constants';
import _ from 'lodash';
import { lsTrackingService, lsI18nService } from 'ls-vue-common';
import {
  ACTIONS_BY_CATEGORY,
  SUPPORTED_ACTIONS,
  ACTION_ROUTE_MAP,
  ACTION_METHOD_MAP,
  BRAND_SUPPORT_ARTICLES_URLS,
} from './support.constants';

export function getSearchableActionsByCategory(
  actions,
  supportedActions = SUPPORTED_ACTIONS,
  actionsByCategory = ACTIONS_BY_CATEGORY
) {
  if (_.isEmpty(actions)) {
    return {};
  }

  return Object.entries(actionsByCategory).reduce((result, entry) => {
    const [categoryKey, actionNames] = entry;

    const category = lsI18nService.translate(`support.categories.${categoryKey}`);
    result[category] = actionNames
      .filter(
        (actionNames) => actionNames !== 'share' || process.env.VUE_APP_BRAND_THEME === LAWNSTARTER
      )
      .filter((actionName) => supportedActions[actionName]);

    return result;
  }, {});
}

export function getLookupByActionName(actions, supportedActions = SUPPORTED_ACTIONS) {
  if (_.isEmpty(actions)) {
    return {};
  }

  return actions.reduce((result, action) => {
    result[action.action] = {
      ...action,
      isEnabled: supportedActions[action.action] || false,
      route: ACTION_ROUTE_MAP[action.action] || '',
      method: ACTION_METHOD_MAP[action.action] || '',
    };
    return result;
  }, {});
}

/**
 *
 * The results returned by fuse.js vary based on the config and the fuse.js version
 * Because this issue has popped up a few times during this feature, we check the shape
 * and normalize if necessary.
 * @param {array} fuseResults
 */

export function normalizeFuseResults(fuseResults) {
  let results = fuseResults;
  if (_.get(fuseResults, '[0].item', '')) {
    results = fuseResults.map((searchItem) => ({ ...searchItem.item }));
  }

  return results.filter(({ action }) => {
    return process.env.VUE_APP_BRAND_THEME === LAWNSTARTER || action !== 'share';
  });
}

export const getBrandArticleUrl = (article) => {
  const DOMAIN = process.env.VUE_APP_BRAND_DOMAIN || 'lawnstarter';
  const articleUrl = BRAND_SUPPORT_ARTICLES_URLS[DOMAIN][article] || '';

  return `https://lawncarehelpcenter.zendesk.com/hc/en-us/articles/${articleUrl}`;
};

export function openTrustFee() {
  window.open(
    // eslint-disable-next-line
        getBrandArticleUrl('trustAndSafetyFee')
  );
  lsTrackingService.track({
    event: 'open-external',
    target: `trust-fee-window`,
  });
}
export function openLongGrassFee() {
  window.open(
    // eslint-disable-next-line
        getBrandArticleUrl('longGrassFee')
  );
  lsTrackingService.track({
    event: 'open-external',
    target: `long-grass-fee`,
  });
}
export function openThreeCutMin() {
  window.open(
    // eslint-disable-next-line
        getBrandArticleUrl('threeCutPolicy')
  );
  lsTrackingService.track({
    event: 'open-external',
    target: `three-cut-min`,
  });
}
